import React from 'react';
import { Modal, ModalProps } from 'antd';

interface AntdModalProps extends ModalProps {}
export const AntdModal = (props: AntdModalProps) => {
    return (
        <div className="stock-antd-table">
            <Modal {...props}></Modal>
        </div>
    );
};
